import { axios } from "../../helper/axios";
 import { DetailsTableconstant } from "./DetailsTableConstant";


const DetailsTableApi = {};

DetailsTableApi.getDetailsTable = ({payload}) => {

  return axios.get(
    DetailsTableconstant.DETAILS_TABLE_API, {params:{ id: payload.id}}
  );

}






export { DetailsTableApi };
